import "./VenueClubDetailsPage.css";
import "./PartyPackageDetailPage.css";
import HeroSectionBox from "./custom-comp/HeroSectionBox.jsx";
import MenuSection from "./custom-comp/MenuSection.jsx";
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import FooterTagSection from "./custom-comp/FooterTagSection.js";
import Package from "./custom-comp/Package.jsx";
import { API_BASE_URL } from "../utils.js";

import { BiDrink } from "react-icons/bi";

import { IoRestaurantSharp } from "react-icons/io5";
import { MdMicExternalOn } from "react-icons/md";
import { MdOutlineRestaurant } from "react-icons/md";
import { MdOutlineTimer } from "react-icons/md";

import { BiSolidDrink } from "react-icons/bi";
import { MdNoDrinks } from "react-icons/md";
import { GoDotFill } from "react-icons/go";
import { FaCircle } from "react-icons/fa6";
import { CiPercent } from "react-icons/ci";
import { BiSolidDiscount } from "react-icons/bi";
import Loginpopup from "../Navbar/Loginmodal.js";
import { useQuery } from "@tanstack/react-query";

export default function PartyPackageDetailPage() {
  const [data, setData] = useState([]);
  const [clubId, setClubId] = useState("");
  // const [events, setEvents] = useState([]);
  // const [menus, setMenus] = useState([]);
  const [packageId, setPackageId] = useState("");
  // const [otherPackages, setOtherPackages] = useState([]);
  // const [otherPackages1, setOtherPackages1] = useState([]);
  // const [teasers, setTeasers] = useState([]);
  const [gallery, setGallery] = useState([]);
  // const [clubData, setClubData] = useState([]);
  // const [bidInfo, setBidInfo] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const userdata = JSON.parse(localStorage.getItem("userData")) || {};

  const navigate = useNavigate();

  //  const sourcePage = searchParams.get("source");

  // const { city, area, club, packageName } = useParams();
  const { packagedetail, title, tab, id } = useParams() || {};
  const [club, city, area] =
    packagedetail?.split("-")?.map((str) => str?.replace(/_/g, " ")) || [];
  const [packageName] =
    title?.split("-")?.map((str) => str?.replace(/_/g, " ")) || [];

  const format = (str) =>
    (str ? str?.trim().replace(/\s+/g, "-").toLowerCase() : "") || "";
  const packageNameParams = format(packageName);

  const newApi = new FormData();
  newApi.append("city", city);
  newApi.append("area", area);
  newApi.append("club", club);

  // package Details
  const fetchPackageDetails = async ({ queryKey }) => {
    const [, packagedetail, title] = queryKey;

    if (!packagedetail || !title) return null;

    const formData = new FormData();
    formData.append("club_slug", packagedetail);
    formData.append("package_slug", title);

    const response = await axios.post(
      `${API_BASE_URL}/master/APIs/Web/packageDetails`,
      formData
    );

    if (
      !response.data.status ||
      !response.data.data ||
      response.data.data.length === 0
    ) {
      console.warn("No package details found", response.data);
      return null;
    }

    return response.data.data[0];
  };

  const {
    data: packageDetails = [],
    isLoading: isLoadingPackageDetails,
    isError: isErrorPackageDetails,
    error: errorPackageDetails,
  } = useQuery({
    queryKey: ["packageDetails", packagedetail, title],
    queryFn: fetchPackageDetails,
    enabled: !!packagedetail && !!title,
    staleTime: 1000 * 60 * 60 * 5,
    cacheTime: 1000 * 60 * 60 * 10,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    if (packageDetails) {
      setData(packageDetails);
      setPackageId(packageDetails.id);
      setClubId(packageDetails.club_id);
    }
  }, [packageDetails]);

  // get Package Menu
  const fetchPackageMenu = async ({ queryKey }) => {
    const [, packageId] = queryKey;
    if (!packageId) return [];

    const formData = new FormData();
    formData.append("package_id", packageId);

    const response = await axios.post(
      `${API_BASE_URL}/master/APIs/ClubPackage/getPackageMenu1`,
      formData
    );

    if (!response.data.status || !response.data.data) {
      console.warn("No data found for getPackageMenu1");
      return [];
    }

    return response.data.data;
  };

  const {
    data: menus = [],
    isLoading: isLoadingMenus,
    isError: isErrorMenus,
    error: errorMenus,
  } = useQuery({
    queryKey: ["packageMenu", packageId],
    queryFn: fetchPackageMenu,
    enabled: !!packageId,
    staleTime: 1000 * 60 * 60 * 5,
    cacheTime: 1000 * 60 * 60 * 10,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  // package Of Same Club
  const fetchOtherPackagesSameClub = async ({ queryKey }) => {
    const [, packageId, clubId] = queryKey;
    if (!packageId || !clubId) return [];

    const formData = new FormData();
    formData.append("package_id", packageId);
    formData.append("club_id", clubId);

    const response = await axios.post(
      `${API_BASE_URL}/master/APIs/ClubPackage/packageOfSameClub`,
      formData
    );

    if (!response.data.status || !response.data.data) {
      console.warn("No data found for packageOfSameClub");
      return [];
    }

    return response.data.data;
  };

  const {
    data: otherPackages = [],
    isLoading: isLoadingOtherPackages,
    isError: isErrorOtherPackages,
    error: errorOtherPackages,
  } = useQuery({
    queryKey: ["otherPackagesSameClub", packageId, clubId],
    queryFn: fetchOtherPackagesSameClub,
    enabled: !!packageId && !!clubId,
    staleTime: 1000 * 60 * 60 * 5,
    cacheTime: 1000 * 60 * 60 * 10,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  // same Package Of Other Club
  const fetchOtherPackages = async ({ queryKey }) => {
    const [, packageId, clubId] = queryKey;
    if (!packageId || !clubId) return [];

    const formData = new FormData();
    formData.append("package_id", packageId);
    formData.append("club_id", clubId);

    const response = await axios.post(
      `${API_BASE_URL}/master/APIs/ClubPackage/samePackageOfOtherClub`,
      formData
    );

    if (!response.data.status || !response.data.data) {
      console.warn("No data found for samePackageOfOtherClub");
      return [];
    }

    return response.data.data;
  };

  const {
    data: otherPackages1 = [],
    isLoading: isLoadingOtherPackages1,
    isError: isErrorOtherPackages1,
    error: errorOtherPackages1,
  } = useQuery({
    queryKey: ["otherPackages1", packageId, clubId],
    queryFn: fetchOtherPackages,
    enabled: !!packageId && !!clubId,
    staleTime: 1000 * 60 * 60 * 5,
    cacheTime: 1000 * 60 * 60 * 10,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  // get Teaser
  const fetchTeasers = async ({ queryKey }) => {
    const [, clubId] = queryKey;
    const apiUrl = `${API_BASE_URL}/master/APIs/Common/getTeaser`;

    // Helper function to fetch by clubId
    const fetchByClubId = async (id) => {
      const formData = new FormData();
      formData.append("club_id", id);

      const response = await axios.post(apiUrl, formData);

      if (response.data.status === true && response.data.data) {
        return response.data.data;
      }

      return null;
    };

    // Try fetching for the given clubId
    let teasers = await fetchByClubId(clubId);

    // Fallback to Admin if no data found
    if (!teasers) {
      teasers = await fetchByClubId("Admin");
      if (!teasers) {
        console.warn("No data found for clubId and Admin fallback");
        return [];
      }
    }

    return teasers;
  };

  const {
    data: teasers = [],
    isLoading: isLoadingTeasers,
    isError: isErrorTeasers,
    error: errorTeasers,
  } = useQuery({
    queryKey: ["teasers", clubId],
    queryFn: fetchTeasers,
    enabled: !!clubId,
    staleTime: 1000 * 60 * 60 * 5,
    cacheTime: 1000 * 60 * 60 * 10,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const {
    data: clubData = [],
    isLoading: isLoadingClub,
    isError: isErrorClub,
    error: errorClub,
  } = useQuery({
    queryKey: ["clubDetails", packagedetail],
    queryFn: async () => {
      if (!packagedetail) return null;

      const formData = new FormData();
      formData.append("slug", packagedetail);

      const response = await axios.post(
        `${API_BASE_URL}/master/APIs/Web/getClubDetails`,
        formData
      );

      if (!response.data?.data) {
        console.warn("No data received from getClubDetails API.");
        return null;
      }

      return response.data.data;
    },
    enabled: !!packagedetail,
    staleTime: 1000 * 60 * 50 * 5,
    cacheTime: 1000 * 60 * 30 * 10,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  // club Wise All Events

  const {
    data: events = [],
    isLoading: isLoadingEvents,
    isError: isErrorEvents,
    error: errorEvents,
  } = useQuery({
    queryKey: ["clubEvents", clubId],
    queryFn: async () => {
      if (!clubId) return [];

      const formData = new FormData();
      formData.append("club_id", clubId);

      const response = await axios.post(
        `${API_BASE_URL}/master/APIs/ClubEvent/clubWiseAllEvents`,
        formData
      );

      if (!response.data.status || !response.data.data) {
        return [];
      }

      return response.data.data;
    },
    enabled: !!clubId, // fetch only if clubId exists
    staleTime: 1000 * 60 * 60 * 5, // 5 minutes fresh
    cacheTime: 1000 * 60 * 60 * 10, // 30 minutes cached
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const {
    data: bidInfo = [],
    isLoading: isLoadingBidInfo,
    isError: isErrorBidInfo,
    error: errorBidInfo,
  } = useQuery({
    queryKey: ["bidInfo", userdata?.id, id],
    queryFn: async () => {
      if (!userdata?.id || !id) return null;

      const formData = new FormData();
      formData.append("user_id", userdata.id);
      formData.append("bid_id", id);

      const response = await axios.post(
        `${API_BASE_URL}/master/APIs/ClubPackage/bidInfo`,
        formData
      );
      if (!response.data.status) {
        throw new Error(response.data.msg || "Failed to fetch bid info");
      }
      return response.data.data;
    },
    enabled: !!userdata?.id && !!id,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const sourcePage = "package";

  const handleBookNow = () => {
    if (sourcePage === "table") {
      navigate(`/table-booking/${id}?sourcePage=${sourcePage}`);
    } else {
      navigate(`/package-booking/${id}?sourcePage=${sourcePage}`);
    }
  };

  const handleLogin = useCallback((ud) => {
    if (ud) {
      localStorage.setItem("userData", JSON.stringify(ud));
      window.location.reload();
      setShowLoginPopup(false);
    }
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    if (!userData) {
      setShowLoginPopup(true);
    }
  }, []);

  return (
    <>
      {id && showLoginPopup && <Loginpopup clbk={handleLogin} isbackendUrl={true} />}
      <div className='vcdp-section '>
        <div className='vcdp-container'>
          <HeroSectionBox id={id} clubData={clubData} data={data} bidInfo={bidInfo} isPartyPackege={true} />

          {id ? (
            <div className="vcdp-container">
              <div className="bid-deatils-section-wrapper">
                <div className="bid-deatil-info-section">
                  <div className="bid-deatils-info-section-boxes">
                    <div className="party-detils-set">
                      <span className="icon-span-24">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="20"
                          viewBox="0 0 18 20"
                          fill="none">
                          <path
                            d="M16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V8H16V18ZM16 6H2V4H16V6ZM6 12H4V10H6V12ZM10 12H8V10H10V12ZM14 12H12V10H14V12ZM6 16H4V14H6V16ZM10 16H8V14H10V16ZM14 16H12V14H14V16Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                      Party Date :dsgfcv
                    </div>
                    <p>{bidInfo?.party_date}</p>
                  </div>
                  <div className="bid-deatils-info-section-boxes">
                    <div className="party-detils-set">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none">
                        <path
                          d="M15.666 1.5H9.66602V3.5H15.666V1.5ZM11.666 14.5H13.666V8.5H11.666V14.5ZM19.696 7.89L21.116 6.47C20.686 5.96 20.216 5.48 19.706 5.06L18.286 6.48C16.736 5.24 14.786 4.5 12.666 4.5C7.69602 4.5 3.66602 8.53 3.66602 13.5C3.66602 18.47 7.68602 22.5 12.666 22.5C17.646 22.5 21.666 18.47 21.666 13.5C21.666 11.38 20.926 9.43 19.696 7.89ZM12.666 20.5C8.79602 20.5 5.66602 17.37 5.66602 13.5C5.66602 9.63 8.79602 6.5 12.666 6.5C16.536 6.5 19.666 9.63 19.666 13.5C19.666 17.37 16.536 20.5 12.666 20.5Z"
                          fill="white"
                        />
                      </svg>
                      Party Time slot :
                    </div>
                    <p>{bidInfo?.party_time} Onwards </p>
                  </div>
                  <div className="bid-deatils-info-section-boxes">
                    <div className="party-detils-set">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none">
                        <path
                          d="M9.93598 5.609H3.47698M18.612 5.0235L12.164 6.551M3.34598 3.045C3.33831 3.3116 3.33431 3.57829 3.33398 3.845C3.33398 9.297 4.84298 13.7165 6.70398 13.7165C8.56498 13.7165 10.074 9.2965 10.074 3.8455C10.0733 3.57583 10.0693 3.30917 10.062 3.0455M11.5335 4.054C11.5868 4.31267 11.6447 4.573 11.707 4.835C12.968 10.139 15.4585 14.089 17.269 13.6585C19.0795 13.228 19.525 8.5795 18.264 3.276C18.2019 3.01644 18.1362 2.75775 18.067 2.5M6.70398 13.997V20.456M3.61498 20.456H9.79298M17.334 13.9315L18.829 20.2155M15.8235 20.93L21.834 19.5005"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Package Type :
                    </div>
                    <p>{bidInfo?.title} </p>
                  </div>
                  <div className="bid-deatils-info-section-boxes">
                    <div className="party-detils-set">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none">
                        <path
                          d="M9.93598 5.609H3.47698M18.612 5.0235L12.164 6.551M3.34598 3.045C3.33831 3.3116 3.33431 3.57829 3.33398 3.845C3.33398 9.297 4.84298 13.7165 6.70398 13.7165C8.56498 13.7165 10.074 9.2965 10.074 3.8455C10.0733 3.57583 10.0693 3.30917 10.062 3.0455M11.5335 4.054C11.5868 4.31267 11.6447 4.573 11.707 4.835C12.968 10.139 15.4585 14.089 17.269 13.6585C19.0795 13.228 19.525 8.5795 18.264 3.276C18.2019 3.01644 18.1362 2.75775 18.067 2.5M6.70398 13.997V20.456M3.61498 20.456H9.79298M17.334 13.9315L18.829 20.2155M15.8235 20.93L21.834 19.5005"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Pax :
                    </div>
                    <p>
                      {Number(bidInfo?.male_qty) + Number(bidInfo?.female_qty)}{" "}
                      Guests
                    </p>
                  </div>
                </div>

                <div className="bid-deatils-section-main">
                  <div className="bid-deatils-section-boxes">
                    <div className="alcoholic-food-section">
                      <p>
                        <BiSolidDrink /> Alcoholic
                      </p>
                      {/* <p><MdNoDrinks /> Non Alcoholic</p> */}
                      <p>
                        {" "}
                        <span className="veg-warp-section">
                          <FaCircle color="#4CAF50" />
                        </span>{" "}
                        Pure Veg
                      </p>
                    </div>
                    <div className="alcoholic-food-section">
                      <p>
                        <MdOutlineRestaurant /> Food -{" "}
                        {data?.nonveg_starter_choice} Starters +{" "}
                        {data?.nonveg_maincourse_choice} Main Course{" "}
                      </p>
                    </div>
                    <div className="alcoholic-food-section">
                      <p>
                        <BiDrink /> Drinks - 2 Mocktails + 2 Soft drinks
                      </p>
                    </div>
                    <div className="alcoholic-food-section">
                      <p>
                        <MdOutlineTimer /> Time - 3 Hours
                      </p>
                    </div>
                    <div className="alcoholic-food-section">
                      <p>
                        <MdMicExternalOn /> Live Music
                      </p>
                    </div>
                    <div className="alcoholic-food-section">
                      <p>
                        <IoRestaurantSharp /> Food – {data?.foodserving}
                      </p>
                    </div>
                    <div className="alcoholic-food-section">
                      <p>
                        <BiDrink /> Drinks – {data?.foodserving}
                      </p>
                    </div>
                  </div>

                  <div className="bid-deatils-section-boxes-right">
                    <div className="bid-deatils-save-instantly">
                      <p>
                        Great Choice! ₹290 would be Saved Instantly on This
                        Booking!
                      </p>
                    </div>

                    <div className="bid-deatils-offer-section">
                      <div className="bid-deatils-offer-section-boxes">
                        <CiPercent color="#7464E4" size={30} />
                        <h1>10% OFF Up To ₹150 </h1>
                        <p>INCLUSIVE OFFER</p>
                      </div>
                      <div className="bid-deatils-offer-section-boxes">
                        <BiSolidDiscount color="#7464E4" size={30} />
                        <h1>10% OFF Up To ₹150 </h1>
                        <p>INCLUSIVE OFFER</p>
                      </div>
                    </div>

                    <div className="bid-deatils-price-section-boxes-right-price">
                      <div className="bdpsbr-left">
                        <div className="bdpsbr-text">
                          <h1>Adult Price </h1>
                          <p>MRP-₹{bidInfo?.male_amount + 1000} </p>
                          <div className="bdpsbr-text-price">
                            <h6>Offer Price ₹{bidInfo?.male_amount}</h6>
                            <p>Kid’s Price</p>
                          </div>
                        </div>
                        <div>
                          <p>
                            Offer ends in
                            <br />
                            06hr 50min
                          </p>
                        </div>
                      </div>

                      <div className="bdpsbr-right">
                        <div className="vcdp-hero-text-2">
                          <div className="vcdp-hero-text-2-text">
                            <h4>Total Party Amount: </h4>
                            <h3>₹ {bidInfo?.total_amount}</h3>
                          </div>
                        </div>

                        <div className="vcdp-hero-text-2">
                          <div className="vcdp-hero-text-2-text">
                            <h4>Advance Booking Amount: </h4>
                            <h3>₹ {bidInfo?.payable_amount}</h3>
                          </div>
                        </div>

                        <div className="vcdp-hero-text-2">
                          <div className="vcdp-hero-text-2-text">
                            <h4>Balance Amount:</h4>
                            <h3>₹ {bidInfo?.due_amount}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <div className="vcdp-content-container">
            <MenuSection
              data={clubData}
              gallery={gallery}
              teasers={teasers}
              menus={menus}
              events={events}
              isPartyPackage={true}
            />

            <div className="party-package-details-page-recommendation-section">
              <h1 className="vcdp-recommendation-section-title title-of-section">
                Other Packages from this Venue
              </h1>
              <div className="vcdp-recommendation-container">
                <Package partypackages={otherPackages} isDetail={true} />
              </div>
            </div>
            <div className="party-package-details-page-recommendation-section">
              <h1 className="vcdp-recommendation-section-title title-of-section">
                {} from the other clubs
              </h1>
              <div className="vcdp-recommendation-container">
                <Package
                  partypackages={otherPackages1}
                  isPartyPackage={true}
                  isDetail={true}
                />
              </div>
            </div>
            <FooterTagSection clubInfo={packagedetail} />
          </div>
        </div>
        {id && (
          <div className="floating-bid-btn-section">
            <button onClick={handleBookNow}>
              Booking Amount ₹ {bidInfo?.payable_amount}
            </button>
          </div>
        )}
      </div>
    </>
  );
}
